var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.32 15.187"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 7.594S4.172.75 10.16.75s9.41 6.844 9.41 6.844-3.422 6.844-9.41 6.844S.75 7.594.75 7.594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.468 7.594a2.308 2.308 0 1 1-2.308-2.308 2.31 2.31 0 0 1 2.308 2.308"
  }))));
};
export default SvgEye;